export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
  { slug: 'school', name: '校园', icon: 'ri-building-line' },
  { slug: 'historical', name: '古风', icon: 'ri-book-open-line' },
];

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  description: string;
  rating: number;
  views: number;
  chapters: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  tags: string[];
  chapters_list: { number: number; title: string; date: string }[];
}

export const featuredComics: Comic[] = [
  {
    id: '1',
    slug: 'wo-de-nan-you-shi-ji-qi-ren',
    title: '我的男友是机器人',
    author: '金智恩',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20romantic%20couple%20with%20a%20futuristic%20robot%20theme%2C%20soft%20pink%20and%20silver%20tones%2C%20elegant%20character%20design%2C%20webtoon%20style%2C%20clean%20background%20with%20subtle%20glow%20effects%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '一个普通女孩意外遇到了来自未来的机器人男友，展开了一段跨越时空的浪漫爱情故事。他拥有完美的外表和温柔的性格，但隐藏着一个惊天秘密...',
    rating: 4.8,
    views: 1520000,
    chapters: 86,
    status: '连载中',
    updatedAt: '2026-08-03',
    tags: ['恋爱', '科幻', '甜宠'],
    chapters_list: [],
  },
  {
    id: '2',
    slug: 'mo-fa-shao-nu-de-qi-yuan',
    title: '魔法少女的奇缘',
    author: '朴秀英',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20magical%20girl%20with%20sparkling%20wand%20and%20flowing%20dress%2C%20fantasy%20elements%2C%20soft%20purple%20and%20gold%20accents%2C%20webtoon%20art%20style%2C%20clean%20simple%20background%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '普通高中生林小雅在一次意外中获得了魔法力量，从此她的生活天翻地覆。在魔法学院里，她结识了志同道合的伙伴，也遇到了命中注定的对手...',
    rating: 4.7,
    views: 1280000,
    chapters: 120,
    status: '连载中',
    updatedAt: '2026-08-02',
    tags: ['奇幻', '校园', '冒险'],
    chapters_list: [],
  },
  {
    id: '3',
    slug: 'hei-an-cheng-bao-de-mi-mi',
    title: '黑暗城堡的秘密',
    author: '李俊昊',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20Korean%20manhwa%20cover%20illustration%20of%20a%20mysterious%20castle%20silhouette%20with%20a%20shadowy%20figure%2C%20thriller%20mood%2C%20deep%20red%20and%20black%20tones%2C%20webtoon%20style%2C%20minimal%20background%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '一座被世人遗忘的古老城堡，隐藏着不为人知的秘密。记者韩智浩深入调查，却发现了一系列令人毛骨悚然的真相，每一个房间都藏着一个故事...',
    rating: 4.9,
    views: 980000,
    chapters: 64,
    status: '已完结',
    updatedAt: '2026-07-28',
    tags: ['悬疑', '恐怖', '推理'],
    chapters_list: [],
  },
  {
    id: '4',
    slug: 'xing-kong-xia-de-yue-ding',
    title: '星空下的约定',
    author: '崔美来',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20illustration%20of%20a%20couple%20under%20a%20starry%20night%20sky%2C%20soft%20warm%20lighting%2C%20gentle%20color%20palette%20with%20pink%20and%20blue%20tones%2C%20webtoon%20art%20style%2C%20clean%20composition%2C%20vertical&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '两个青梅竹马的朋友，在星空下许下了永远的约定。多年后重逢，曾经的约定是否还在？一段纯真又令人心动的初恋故事。',
    rating: 4.6,
    views: 2100000,
    chapters: 95,
    status: '已完结',
    updatedAt: '2026-07-25',
    tags: ['恋爱', '校园', '治愈'],
    chapters_list: [],
  },
  {
    id: '5',
    slug: 'zui-hou-de-jian-ke',
    title: '最后的剑客',
    author: '郑宇成',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20cover%20illustration%20of%20a%20swordsman%20in%20traditional%20clothing%20with%20flowing%20cape%2C%20action%20pose%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20brown%20tones%2C%20webtoon%20art%20style%2C%20clean%20minimal%20background%2C%20vertical&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '在科技主宰的世界里，最后一位传统剑客开始了他的复仇之路。古老武艺与现代武器的碰撞，谁能笑到最后？',
    rating: 4.5,
    views: 760000,
    chapters: 72,
    status: '连载中',
    updatedAt: '2026-08-01',
    tags: ['动作', '武侠', '热血'],
    chapters_list: [],
  },
  {
    id: '6',
    slug: 'gao-xiao-tian-tuan',
    title: '搞笑天团',
    author: '韩美娜',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20bright%20Korean%20manhwa%20cover%20illustration%20of%20quirky%20characters%20in%20a%20comedy%20scene%2C%20vibrant%20colors%2C%20expressive%20faces%2C%20webtoon%20style%2C%20clean%20simple%20background%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '一群性格各异的朋友组成了一个搞笑团体，每天都上演着令人捧腹大笑的故事。生活不易，但快乐可以很简单！',
    rating: 4.4,
    views: 890000,
    chapters: 150,
    status: '连载中',
    updatedAt: '2026-08-03',
    tags: ['搞笑', '日常', '友情'],
    chapters_list: [],
  },
];

export const latestComics: Comic[] = [
  {
    id: '7',
    slug: 'chong-sheng-zhi-nu-wang-gui-lai',
    title: '重生之女王归来',
    author: '尹素婉',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20cover%20illustration%20of%20an%20elegant%20confident%20woman%20in%20a%20power%20pose%2C%20dramatic%20lighting%2C%20gold%20and%20burgundy%20tones%2C%20webtoon%20style%2C%20clean%20minimal%20background%2C%20vertical&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '前世被陷害致死，今生她带着记忆重生。这一次，她要将所有伤害过她的人踩在脚下，重新夺回属于自己的一切！',
    rating: 4.7,
    views: 650000,
    chapters: 45,
    status: '连载中',
    updatedAt: '2026-08-04',
    tags: ['剧情', '重生', '女性向'],
    chapters_list: [],
  },
  {
    id: '8',
    slug: 'xue-xiao-guai-tan',
    title: '学校怪谈',
    author: '张东民',
    category: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20creepy%20Korean%20manhwa%20cover%20illustration%20of%20a%20haunted%20school%20corridor%20with%20eerie%20atmosphere%2C%20dark%20green%20and%20gray%20tones%2C%20ghostly%20figure%2C%20webtoon%20horror%20style%2C%20minimal%20background%2C%20vertical&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '深夜的校园里，总有一些不为人知的怪事发生。一群好奇心旺盛的学生决定揭开这些诡异事件背后的真相...',
    rating: 4.3,
    views: 430000,
    chapters: 38,
    status: '连载中',
    updatedAt: '2026-08-03',
    tags: ['恐怖', '校园', '灵异'],
    chapters_list: [],
  },
  {
    id: '9',
    slug: 'gu-feng-mei-ren-mou',
    title: '古风美人谋',
    author: '安素妍',
    category: 'historical',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20of%20a%20traditional%20hanbok-clad%20woman%20in%20ancient%20setting%2C%20elegant%20classical%20style%2C%20soft%20jade%20and%20peach%20tones%2C%20webtoon%20art%2C%20clean%20simple%20background%2C%20vertical&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '古代朝鲜王朝背景下，一位聪慧的女子凭借智慧在宫廷中步步为营。权谋、爱情、友情交织，谱写一曲动人史诗。',
    rating: 4.8,
    views: 720000,
    chapters: 56,
    status: '连载中',
    updatedAt: '2026-08-02',
    tags: ['古风', '宫斗', '爱情'],
    chapters_list: [],
  },
  {
    id: '10',
    slug: 'tian-cai-you-hua-shi',
    title: '天才油画师',
    author: '徐智敏',
    category: 'school',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20of%20a%20young%20artist%20painting%20with%20passion%2C%20colorful%20art%20studio%20vibes%2C%20warm%20natural%20light%2C%20creative%20atmosphere%2C%20webtoon%20style%2C%20clean%20background%2C%20vertical&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '天生色弱的少年却拥有惊人的绘画天赋，他用独特的方式感知色彩，在艺术学院中创造了一个又一个奇迹。',
    rating: 4.6,
    views: 540000,
    chapters: 68,
    status: '连载中',
    updatedAt: '2026-08-01',
    tags: ['校园', '艺术', '励志'],
    chapters_list: [],
  },
  {
    id: '11',
    slug: 'yi-jie-zhi-wang',
    title: '异界之王',
    author: '金泰亨',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20epic%20Korean%20manhwa%20cover%20illustration%20of%20a%20powerful%20warrior%20in%20fantasy%20armor%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20golden%20and%20deep%20blue%20tones%2C%20webtoon%20art%20style%2C%20clean%20background%2C%20vertical&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '普通上班族穿越到异世界，凭借现代知识在剑与魔法的世界中闯出一片天地，最终成为异界之王的传奇故事。',
    rating: 4.5,
    views: 870000,
    chapters: 92,
    status: '连载中',
    updatedAt: '2026-08-04',
    tags: ['奇幻', '穿越', '冒险'],
    chapters_list: [],
  },
  {
    id: '12',
    slug: 'mi-mi-lian-ren',
    title: '秘密恋人',
    author: '刘智雅',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20secretive%20Korean%20manhwa%20cover%20illustration%20of%20a%20couple%20hiding%20their%20relationship%2C%20soft%20blush%20pink%20and%20cream%20tones%2C%20intimate%20atmosphere%2C%20webtoon%20style%2C%20clean%20minimal%20background%2C%20vertical&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '当红偶像与普通白领的秘密恋情，在聚光灯下小心翼翼地守护着彼此。一场意外让他们的关系面临考验...',
    rating: 4.7,
    views: 1130000,
    chapters: 78,
    status: '连载中',
    updatedAt: '2026-08-02',
    tags: ['恋爱', '娱乐圈', '甜宠'],
    chapters_list: [],
  },
];

export const allComics: Comic[] = [...featuredComics, ...latestComics];

for (const comic of allComics) {
  const count = comic.chapters;
  comic.chapters_list = [];
  for (let i = count; i >= 1; i--) {
    comic.chapters_list.push({
      number: i,
      title: i === 1 ? '第1话 序章' : `第${i}话`,
      date: new Date(2026, 7, 1 - i).toISOString().split('T')[0],
    });
  }
}

export const faqs = [
  {
    question: '韩国漫画网上的漫画都是免费的吗？',
    answer: '是的！韩国漫画网上的所有漫画资源均为免费提供。我们致力于为广大漫画爱好者打造一个无需付费即可畅享海量韩漫的平台，让每一位读者都能随时随地享受精彩的韩国漫画。',
  },
  {
    question: '网站上的漫画多久更新一次？',
    answer: '我们每日更新漫画内容，确保读者能够第一时间看到最新的韩漫章节。热门连载漫画通常保持在每周至少更新一次的频率，部分高热作品可能会更频繁地更新。',
  },
  {
    question: '如何在手机上阅读漫画？',
    answer: '韩国漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。您只需在手机浏览器中打开我们的网站，即可享受流畅的漫画阅读体验，无需下载任何App。',
  },
  {
    question: '网站上的漫画有中文翻译吗？',
    answer: '所有漫画均提供高质量的中文翻译。我们的翻译团队严格把控翻译质量，力求在保留原作精髓的同时，为中文读者提供最自然流畅的阅读体验。',
  },
  {
    question: '可以在网站上搜索特定的漫画吗？',
    answer: '当然可以！我们提供便捷的搜索功能和分类筛选系统，您可以通过漫画名称、作者、标签等多种方式快速找到想看的内容。',
  },
  {
    question: '如何收藏喜欢的漫画？',
    answer: '您可以通过浏览器的书签功能收藏喜欢的漫画页面。我们也在计划推出用户账户系统，届时将支持在线收藏、阅读记录等更多便捷功能。',
  },
];

export const reviews = [
  {
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20Korean%20style%20anime%20girl%20avatar%20portrait%2C%20simple%20clean%20background%2C%20soft%20warm%20lighting%2C%20friendly%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '这是我看过最好的韩漫网站！更新速度超快，翻译质量也很高。每天晚上睡前必刷，已经成了我的日常习惯~',
    date: '2026-07-28',
  },
  {
    name: '阿强',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20Korean%20style%20anime%20boy%20avatar%20portrait%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20calm%20expression&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '分类很全面，找漫画特别方便。界面设计也很清爽，没有烦人的广告弹窗，阅读体验一级棒！强烈推荐给所有韩漫爱好者。',
    date: '2026-07-25',
  },
  {
    name: '小美',
    avatar: 'https://readdy.ai/api/search-image?query=A%20pretty%20Korean%20style%20anime%20girl%20avatar%20portrait%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20smiling%20expression&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '漫画种类非常丰富，从热门的恋爱漫画到冷门的恐怖题材都能找到。唯一希望的是能增加更多完结漫画的收录。',
    date: '2026-07-20',
  },
  {
    name: '大鹏',
    avatar: 'https://readdy.ai/api/search-image?query=A%20handsome%20Korean%20style%20anime%20boy%20avatar%20portrait%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20cool%20expression&width=100&height=100&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '朋友推荐来的，一开始只是随便看看，结果一看就停不下来了！《最后的剑客》真的太好看了，每天都在等更新。',
    date: '2026-07-18',
  },
  {
    name: '莉莉',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20Korean%20style%20anime%20girl%20avatar%20portrait%2C%20simple%20clean%20background%2C%20warm%20lighting%2C%20happy%20expression&width=100&height=100&seq=avatar-05&orientation=squarish',
    rating: 5,
    content: '网站的画质太赞了！每张漫画封面都是高清的，而且加载速度很快。最爱的就是恋爱分类，每一部都甜到爆炸！',
    date: '2026-07-15',
  },
];